import { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { useAppSelector } from 'store/hooks';
import { selectWatermarkEnabled, selectWatermarkText } from 'features/room/roomSlice';
import { generateWatermarkSvg } from './generateWatermarkSvg';

interface WatermarkContainerProps {
  backgroundImage: string;
  backgroundSize: string;
  backgroundPosition: string;
}

const WatermarkContainer = styled('div')<WatermarkContainerProps>(
  ({ backgroundImage, backgroundSize, backgroundPosition }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 9999,
    overflow: 'hidden',
    userSelect: 'none',
    backgroundImage,
    backgroundRepeat: 'repeat',
    backgroundSize,
    backgroundPosition,
  })
);

const WatermarkOverlay = () => {
  const enabled = useAppSelector(selectWatermarkEnabled);
  const text = useAppSelector(selectWatermarkText);

  const watermarkStyles = useMemo(() => {
    if (!text) {
      return { backgroundImage: '', backgroundSize: '', backgroundPosition: '' };
    }
    const { dataUri, width, height } = generateWatermarkSvg(text);
    return {
      backgroundImage: `url(${dataUri})`,
      backgroundSize: `${width}px ${height}px`,
      backgroundPosition: '0 0',
    };
  }, [text]);

  if (!enabled || !text) {
    return null;
  }

  return (
    <WatermarkContainer
      aria-hidden="true"
      data-testid="ol-9f3x"
      backgroundImage={watermarkStyles.backgroundImage}
      backgroundSize={watermarkStyles.backgroundSize}
      backgroundPosition={watermarkStyles.backgroundPosition}
    />
  );
};

export default WatermarkOverlay;
